import Route from '@ember/routing/route';

import type { ProgramsProgramCohortModel } from '../../cohort.ts';

export type ProgramsProgramCohortContentAnnouncementsModel =
  ProgramsProgramCohortModel;

export default class ProgramsProgramCohortContentAnnouncementsRoute extends Route<ProgramsProgramCohortContentAnnouncementsModel> {
  model() {
    return this.modelFor(
      'programs.program.cohort'
    ) as ProgramsProgramCohortModel;
  }
}
